enum AssetTypeConstants {
  ROBOTIC = 'ROBOTIC',
  ROBOTIC_MOWER = 'ROBOTIC_MOWER',
  HANDHELD = 'HANDHELD',
  RIDE_ON = 'RIDE_ON',
  WALK_BEHIND = 'WALK_BEHIND',
  BATTERY = 'BATTERY',
  CONSTRUCTION = 'CONSTRUCTION',
  GENERAL_ACCESSORIES = 'GENERAL_ACCESSORIES',
}

export default AssetTypeConstants;
